<template>
  <div>
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="4" :sm="24">
            <a-form-item label="飞机识别号">
              <a-input v-model="queryParam.number" placeholder="请输入" allow-clear/>
            </a-form-item>
          </a-col>
          <a-col :md="2" :sm="24">
            <a-button type="primary" icon="search" @click="$refs.table.refresh(true)">查询</a-button>
          </a-col>
          <a-col :md="1" :sm="24">
            <a-button type="primary" icon="plus" @click="handleAdd" v-if="false">新建</a-button>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <s-table
      ref="table"
      size="small"
      rowKey="id"
      :loading="loading"
      :columns="columns"
      :pageNum="pageNum"
      :data="loadData"
      :scroll="{ x: 1000 }"
    >
      <span slot="serial" slot-scope="text, record, index">
        {{ index + 1 }}
      </span>
      <span slot="image" slot-scope="img">
        <a-avatar
          slot="img"
          :src="img"
          shape="square"
          @click="openPreview(img)"
        />
      </span>
      <div slot="money_render" slot-scope="text">
        {{ (text / 100).toFixed(2) | numberFormat }}
      </div>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="openPreview(record)">查看</a>
        </template>
      </span>
    </s-table>
    <a-modal v-model="previewVisible" title="预览" width="850px" :footer="null">
      <a-row>
        <a-col :span="12">
          <div style="border-right: 1px solid #efefef; text-align: center">
            <h2 style="text-align: center">入场照片</h2>
            <img alt="入场照片" style="width: 400px; margin: 0 auto" :src="previewInUrl" />
          </div>
        </a-col>
        <a-col :span="12">
          <div style="text-align: center">
            <h2 style="text-align: center">出场照片</h2>
            <img alt="出场照片" style="width: 400px; margin: 0 auto" :src="previewOutUrl" />
          </div>
        </a-col>
      </a-row>
    </a-modal>
    <create-form
      ref="createModal"
      :visible="visible"
      :loading="confirmLoading"
      @cancel="handleCreateCancel"
      @ok="handleCreateOk"
    />
  </div>
</template>

<script>
import { STable } from '@/components'
import { Dictionaries } from '@/common/AllConstant'
import CreateForm from '../modules/CreateForm'
import {
  monitor_plane_record_create,
  monitor_plane_record_delete,
  monitor_plane_record_list, monitor_plane_record_update
} from '@/api/monitor_plane'

export default {
  name: 'TableList',
  components: {
    STable,
    CreateForm
  },
  data () {
    return {
      pageNum: 1,
      dataSource: [],
      corporation_id: null,
      previewVisible: false,
      previewInUrl: undefined,
      previewOutUrl: undefined,
      corList: [],
      loading: false,
      confirmLoading: false,
      dictionaries: Dictionaries,
      // 创建窗口控制
      visible: false,
      mdl: {},
      // 查询参数
      queryParam: {},
      // 表头
      columns: [
        {
          fixed: 'left',
          title: '序号',
          width: 50,
          scopedSlots: { customRender: 'serial' }
        },
        {
          title: '飞机识别号',
          dataIndex: 'number',
          width: 150,
          ellipsis: true
        },
        {
          title: '费用',
          scopedSlots: { customRender: 'money_render' },
          align: 'right',
          width: 150,
          dataIndex: 'total_fees'
        },
        {
          title: '进入时间',
          width: 150,
          align: 'center',
          dataIndex: 'in_time'
        },
        {
          title: '出场时间',
          width: 150,
          align: 'center',
          dataIndex: 'out_time'
        },
        {
          fixed: 'right',
          title: '操作',
          dataIndex: 'action',
          width: 200,
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        console.log('loadData.parameter', parameter)
        return monitor_plane_record_list(Object.assign(parameter, this.queryParam))
          .then(res => {
            console.log(res.data, '我是数据列表@')
            return res.data
          })
      },
      selectedRowKeys: [],
      selectedRows: []
    }
  },
  created () {
    this.setCurrentPage()
    const id = this.$route.params.id
    if (id) {
      this.queryParam.id = id
    }
  },
  methods: {
    setCurrentPage () {
      const page = this.$store.getters.pop
      if (page) {
        console.log('获取到的page：', page)
        const current = page.split('#$$#')[0]
        const query = page.split('#$$#')[1]
        const path = page.split('#$$#')[2]
        sessionStorage.removeItem('GuaranteeCurrentPage')
        if (path === this.$route.path) {
          if (!isNaN(Number(current))) {
            this.pageNum = Number(current)
          }
          if (query) {
            this.queryParam = JSON.parse(query)
          }
        } else {
          this.queryParam = {}
          this.$store.dispatch('clear')
        }
      } else {
        console.log('这是个空的page')
      }
    },
    handleAdd () {
      this.mdl = null
      this.visible = true
    },
    handleCreateCancel () {
      this.visible = false
      const form = this.$refs.createModal.form
      form.resetFields() // 清理表单数据（可不做）
    },
    handleCreateOk (data) {
      console.log(data)
      monitor_plane_record_create(data).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handlePayed (record) {
      monitor_plane_record_update({ status: 1 }, record.id).then(res => {
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    handleDelete (record) {
      monitor_plane_record_delete(record.id).then((res) => {
        console.log(res)
        if (res.code === 1000) {
          this.$refs.table.refresh()
        }
      })
    },
    openPreview (record) {
      if (record === undefined || record === null) {
        return
      }
      this.previewVisible = true
      this.previewInUrl = record.in_image
      this.previewOutUrl = record.out_image
    }
  }
}
</script>
